import React from 'react';
import { Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { uid } from '@/lib/officialsApi';
import { TimeRange } from './TimeRange';

export const DayEditorDialog = ({ date, entries, update, onClose }) => {
  const rows = entries.filter(e => e.date === date);
  const setDay = (list) => update(p => [...p.filter(e => e.date !== date), ...list]);
  const label = date && new Date(`${date}T00:00:00`).toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
  return (
    <Dialog open={!!date} onOpenChange={o => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="day-editor-dialog">
        <DialogHeader>
          <DialogTitle className="text-[#00247D]">{label}</DialogTitle>
          <DialogDescription>Overrides your weekly hours for this date only.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" className="border-emerald-300 text-emerald-700 hover:bg-emerald-50" data-testid="day-available-all"
            onClick={() => setDay([{ id: uid(), type: 'available', date, start: '', end: '' }])}>Available all day</Button>
          <Button variant="outline" className="border-red-300 text-red-700 hover:bg-red-50" data-testid="day-unavailable-all"
            onClick={() => setDay([{ id: uid(), type: 'unavailable', date, start: '', end: '' }])}>Unavailable all day</Button>
        </div>
        <div className="space-y-2">
          {rows.map((e, i) => (
            <TimeRange key={e.id} e={e} typeSelect testId={`day-range-${i}`}
              onChange={patch => update(p => p.map(x => (x.id === e.id ? { ...x, ...patch } : x)))}
              onRemove={() => update(p => p.filter(x => x.id !== e.id))} />
          ))}
          {!rows.length && <p className="text-sm text-slate-400">Nothing set for this date. Your weekly hours apply.</p>}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button variant="ghost" size="sm" className="text-[#00247D]" data-testid="day-add-range"
            onClick={() => update(p => [...p, { id: uid(), type: 'available', date, start: '09:00', end: '17:00' }])}>
            <Plus className="w-4 h-4 mr-1" />Add time range
          </Button>
          {rows.length > 0 && <Button variant="ghost" size="sm" className="text-slate-500" onClick={() => setDay([])} data-testid="day-clear">Clear day</Button>}
          <Button onClick={onClose} className="ml-auto bg-[#00247D] hover:bg-[#001A5C]" data-testid="day-done">Done</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
